"use client";
import { useState, useLayoutEffect, useCallback } from "react";
import Heading from "@/components/ui/Heading";
import { useTranslations } from "next-intl";

const strings = [
  "Good day",
  "Bonjour",
  "Guten Tag",
  "Buenos dias",
  "Hola",
  "Buon&shy;giorno",
  "Ciao",
  "Olá",
  "Hallo",
  "Hej",
  "Hei",
  "Hei hei",
  "Bom dia",
  "Dobry den",
  "God dag",
  "Goeden&shy;dag",
  "Hyvää päivää",
  "Góðan dag",
  "Günaydin",
  "Dzień dobry",
  "Kalimera",
  "Namaste",
  "Sawubona",
  "Konnichi&shy;wa",
  "A&shy;nyeong&shy;ha&shy;se&shy;yo",
  "Ni hao",
  "Sa&shy;lam",
  "Sveiki",
  "Zdravo",
  "Merhaba",
  "Shalom",
  "Sa&shy;laam-alai&shy;kum",
  "Alai&shy;kum-sa&shy;laam",
  "Zdrav&shy;stvuyte",
  "Nama&shy;skar",
  "Nama&shy;skaram",
  "Nama&shy;skara",
  "Nama&shy;skara&shy;galu",
];

const AboutHeading = () => {
  const t = useTranslations("about");
  const getHeading = useCallback(
    (string: string) => `${string}, \\${t("title")}`,
    [t]
  );
  const [intro, setIntro] = useState<string>(getHeading(strings[0]));

  useLayoutEffect(() => {
    setIntro(getHeading(strings[Math.floor(Math.random() * strings.length)]));
  }, [getHeading]);
  return (
    <>
      <Heading
        level={2}
        variant="h6"
        className="md:section-px ~mt-6/20 max-md:text-primary">
        {t("pre")}
      </Heading>
      <Heading
        fx
        className="hyphens-auto text-center !leading-[0.935] ~text-[3.25rem]/[6rem] ~mt-1/2 md:text-left md:~-ml-40/56">
        {intro}
      </Heading>

      {/* ~text-[3.25rem]/[7rem] ~leading-[3.375rem]/[7.5rem] */}
    </>
  );
};

export default AboutHeading;
